import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { DataService_StudentFinesDebts } from "../shared/data.service";
import { StudentFineInsertRequest } from "../shared/StudentFineInsertRequest";
import * as moment from "moment";

@Component({
	selector: "app-student-add-fine",
	templateUrl: "./student-add-fine.component.html",
	styleUrls: ["./student-add-fine.component.css"],
})
export class StudentAddFineComponent implements OnInit {
	constructor(
		private dialogConfig: DynamicDialogConfig,
		private ref: DynamicDialogRef,
		private confirmationService: ConfirmationService,
		private StudentFinesDebtsService: DataService_StudentFinesDebts
	) {}

	ngOnInit(): void {
		this.user = this.dialogConfig.data.user;
		this.SelectedPerson = this.dialogConfig.data.SelectedPerson;
		this.CurrentBalance = this.dialogConfig.data.CurrentBalance;

		this.StudentID = this.SelectedPerson.DesignatorID;
		this.StudentName = this.SelectedPerson.PersonName;
		this.CurrentBalanceDesc = "$" + this.CurrentBalance;
		this.UpdatedBalance = "$" + this.CurrentBalance;

		this.loadFineTypes();
	}

	////////////////////////////////////////////////
	// Data
	////////////////////////////////////////////////

	//From parent
	user: any;
	SelectedPerson: any;
	CurrentBalance: any;

	StudentID: any = "";
	StudentName: any = "";
	CurrentBalanceDesc: any = "";

	//Form
	FineType: any;
	lstFineType: any = [];
	FineAmount: any = 0;
	Comments: any = "";

	UpdatedBalance: any = "";

	errorMessage: any = "";

	////////////////////////////////////////////////

	////////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////////
	loadFineTypes() {
		var result = this.StudentFinesDebtsService.LoadFineTypes(this.SelectedPerson.SchoolID);
		result.subscribe(
			(response) => {
				// console.log(response);

				this.lstFineType = response;

				this.FineType = this.lstFineType[0];
				this.FineAmount = Number(this.FineType.AccountDebitDefaultAmount);
				this.UpdateBalance();
			},
			(error) => {}
		);
	}
	////////////////////////////////////////////////

	////////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////////
	onAdd() {
		this.errorMessage = "";

		//Error handling
		if (this.FineType == undefined) {
			this.errorMessage = "Must select a fine type";
			return;
		}

		this.FineAmount = Number(this.FineAmount).toFixed(2);

		if (this.FineAmount < 0) {
			this.errorMessage = "Fine amount must be > 0";
			return;
		}

		if (this.FineAmount > 99.99) {
			this.errorMessage = "Fine amount must be < 100";
			return;
		}

		let parms: StudentFineInsertRequest = {
			AccountDebitTypeID: this.FineType.AccountDebitTypeID,
			PersonID: this.SelectedPerson.PersonID,
			Administrator_PersonID: this.user.personID,
			AccountDebitDT: moment(new Date()).format("MM/DD/YYYY HH:mm:00"),
			AccountDebitAmount: this.FineAmount,
			AccountDebitBalance: this.FineAmount,
			AccountDebitComment: this.Comments,
			SchoolID: this.SelectedPerson.SchoolID,
		};

		//Call SP
		var result = this.StudentFinesDebtsService.StudentFineInsert(parms);
		result.subscribe(
			(response) => {
				if (response) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "add",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Fine was added successfully",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.ref.close(1);
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "add",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not add the Fine",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {}
		);
	}

	onClose() {
		this.ref.close(0);
	}
	////////////////////////////////////////////////

	////////////////////////////////////////////////
	// Events
	////////////////////////////////////////////////
	onFineTypeChange(val) {
		this.FineType = val;

		//Adjust amount to be default for the fine type
		this.FineAmount = Number(this.FineType.AccountDebitDefaultAmount);

		this.UpdateBalance();
	}

	onFineAmountChange(val) {
		this.FineAmount = val;

		this.UpdateBalance();
	}

	UpdateBalance() {
		this.UpdatedBalance = "$" + (Number(this.CurrentBalance) + Number(this.FineAmount)).toFixed(2);
	}
	////////////////////////////////////////////////
}
